import { Component, Inject, InjectionToken, Injector } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';

export type TDataFieldEditCalendarComponent_Settings = {
    isOutlineLayout?: boolean;
};
export const DataFieldEditCalendarComponent_Settings = new InjectionToken<TDataFieldEditCalendarComponent_Settings>(
    'DataFieldEditCalendarComponent_Settings',
);

@Component({
    selector: 'data-field-edit-custom-calendar',
    templateUrl: './custom-calendar.component.html',
    standalone: false,
})
export class DataFieldEditCustomCalendarComponent extends DataFieldEditBase {
    constructor(
        injector: Injector,
        @Inject(DataFieldEditCalendarComponent_Settings) public settings: TDataFieldEditCalendarComponent_Settings,
    ) {
        super(injector);
    }

    isOutlineLayout(): boolean {
        return this.settings?.isOutlineLayout;
    }
}
